import { render, staticRenderFns } from "./PrioritiesSelect.vue?vue&type=template&id=175f0942&"
import script from "./PrioritiesSelect.vue?vue&type=script&lang=js&"
export * from "./PrioritiesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports